import ListItemComponent from '../../../../stories/molecules/list-items'
import { listItemListViewVariantOptions } from '../../../../stories/molecules/list-items/constants'
import {
  LoadingContainer,
  ProjectMembersTabMembersContainer
} from '../../../styled-components'
import ProjectMembersEmptyList from '../project-member-empty-list'
import { projectMembersTabOptions } from '../../../constants'
import { isEmpty } from 'lodash'
import ContactItem from './contact-item'
import { SpinnerGrey } from '../../../../stories/atoms/icons/special'
import { iconSizeOptions } from '../../../../stories/atoms/icons/icons-sizes'
import PropTypes from 'prop-types'

const ContactsList = ({ contacts = [], isLoading = false }) => {
  if (isLoading) {
    return (
      <LoadingContainer>
        <SpinnerGrey size={iconSizeOptions['ICON-XL']} />
      </LoadingContainer>
    )
  }

  if (isEmpty(contacts)) {
    return (
      <ProjectMembersEmptyList variant={projectMembersTabOptions.CONTACTS} />
    )
  }

  return (
    <ProjectMembersTabMembersContainer>
      <ListItemComponent.Root
        listViewType={listItemListViewVariantOptions.TOGETHER}
        dividerFull={false}
        hideDivider
        style={{
          border: 'none'
        }}
      >
        {contacts.map((item) => {
          return <ContactItem key={item.id} item={item} />
        })}
      </ListItemComponent.Root>
    </ProjectMembersTabMembersContainer>
  )
}

ContactsList.propTypes = {
  contacts: PropTypes.array,
  isLoading: PropTypes.bool
}

export default ContactsList
